import { render, staticRenderFns } from "./RequestDetailsModal.vue?vue&type=template&id=4083cf22&scoped=true"
import script from "./RequestDetailsModal.vue?vue&type=script&lang=js"
export * from "./RequestDetailsModal.vue?vue&type=script&lang=js"
import style0 from "./RequestDetailsModal.vue?vue&type=style&index=0&id=4083cf22&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4083cf22",
  null
  
)

export default component.exports